const baseUrl = process.env.PUBLIC_URL;

export function publicUrlFor(path) {
  if (!path) return "";
  if (/^(https?:)?\/\//i.test(path) || path.startsWith("data:")) {
    return path;
  }
  if (path.startsWith("/")) {
    return baseUrl ? baseUrl + path : path;
  }
  return baseUrl + "/assets/" + path;
}

export function loadScript(src, fromPublic) {
  return new Promise(function (resolve, reject) {
    var scriptSrc = (
      fromPublic === undefined ||
      fromPublic == null ||
      fromPublic
    )
      ? publicUrlFor(src)
      : src;
    var existingScript = document.querySelector('script[src="' + scriptSrc + '"]');

    if (existingScript) {
      if (existingScript.getAttribute("data-loaded") === "true") {
        resolve();
        return;
      }
      existingScript.addEventListener("load", function () {
        resolve();
      }, { once: true });
      existingScript.addEventListener("error", function (e) {
        reject(e);
      }, { once: true });
      return;
    }

    var script = document.createElement("script");
    script.src = scriptSrc;

    script.addEventListener("load", function () {
      script.setAttribute("data-loaded", "true");
      resolve();
    }, { once: true });
    script.addEventListener("error", function (e) {
      reject(e);
    }, { once: true });

    document.body.appendChild(script);
  });
}
